export enum AlertTypeEnum {
    success = 'success',
    warning = 'warning',
    error = 'error',
    info = 'info',
}
